"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.composeLocation = exports.composeLanguage = exports.composeTitleFromName = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */ // @ts-nocheck
var expertAutocomplete_1 = require("../expertAutocomplete");
var staticData_store_1 = tslib_1.__importDefault(require("../stores/staticData.store"));
/**
 *
 * @param {{firstName: string, countryId?: number}[]} names
 * @returns {{firstName: string, countryId?: number, title?: string}[]} response
 */
var composeTitleFromName = function (names) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var result;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!Array.isArray(names) || names.length < 1) {
                    return [2 /*return*/, []];
                }
                return [4 /*yield*/, (0, expertAutocomplete_1.getGenderFromName)(names.map(function (e) {
                        var foundCountry = null;
                        if (e.countryId) {
                            foundCountry = staticData_store_1.default.countries.find(function (country) { return country.id == e.countryId; });
                        }
                        return {
                            names: [{ name: e.firstName, country_iso2: foundCountry === null || foundCountry === void 0 ? void 0 : foundCountry.isoCode2 }],
                        };
                    }))];
            case 1:
                result = _a.sent();
                if (result && result.length > 0) {
                    return [2 /*return*/, result.map(function (e) {
                            var foundCountry = null;
                            if (e.country_iso2) {
                                foundCountry = staticData_store_1.default.countries.find(function (country) { return country.isoCode2 == e.country_iso2; });
                            }
                            return {
                                firstName: e.name,
                                countryId: foundCountry === null || foundCountry === void 0 ? void 0 : foundCountry.id,
                                title: e.gender === 'male' ? 'Mr.' : e.gender === 'female' ? 'Ms.' : undefined,
                            };
                        })];
                }
                else {
                    return [2 /*return*/, []];
                }
                return [2 /*return*/];
        }
    });
}); };
exports.composeTitleFromName = composeTitleFromName;
/**
 *
 * @param { input: string } input
 * @returns {{ id: number, oldNid: number, name: string, isoCode2: string}}
 */
var composeLanguageFromText = function (input) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var response, sortedLanguages, highestScoredResult_1;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!input) {
                    return [2 /*return*/, null];
                }
                return [4 /*yield*/, (0, expertAutocomplete_1.getLanguageFromText)(input)];
            case 1:
                response = _a.sent();
                if (response && Array.isArray(response.Languages) && response.Languages.length > 0) {
                    sortedLanguages = response.Languages.sort(function (a, b) {
                        return a.Score - b.Score;
                    }).reverse();
                    highestScoredResult_1 = sortedLanguages[0];
                    return [2 /*return*/, staticData_store_1.default.languages.find(function (e) { return e.isoCode2 == highestScoredResult_1.LanguageCode; })];
                }
                else {
                    return [2 /*return*/, null];
                }
                return [2 /*return*/];
        }
    });
}); };
/**
 *
 * @param {{ text: string, countryId?: number }} input
 * @returns {{ id: number, name: string, updated: boolean, languageToUser: { languageId: number, languageProficiencyId: number }, isoCode2: string }[]}
 */
var composeLanguage = function (input) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var foundLanguage_1, err_1, foundCountry_1, foundlanguages, foundLanguage;
    var _a;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!(input === null || input === void 0 ? void 0 : input.text)) return [3 /*break*/, 4];
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, composeLanguageFromText((_a = input.text) === null || _a === void 0 ? void 0 : _a.trim())];
            case 2:
                foundLanguage_1 = _b.sent();
                if (foundLanguage_1) {
                    // Found by text
                    return [2 /*return*/, [
                            {
                                id: foundLanguage_1.id,
                                name: foundLanguage_1.name,
                                updated: true,
                                languageToUser: {
                                    languageId: foundLanguage_1.id,
                                    languageProficiencyId: 3,
                                },
                                isoCode2: foundLanguage_1.isoCode2,
                            },
                        ]];
                }
                return [3 /*break*/, 4];
            case 3:
                err_1 = _b.sent();
                console.log("Couldn't find language from text.");
                return [3 /*break*/, 4];
            case 4:
                if (input === null || input === void 0 ? void 0 : input.countryId) {
                    try {
                        foundCountry_1 = staticData_store_1.default.countries.find(function (country) { return country.id == input.countryId; });
                        if (foundCountry_1 && foundCountry_1.languageIds && Array.isArray(JSON.parse(foundCountry_1.languageIds))) {
                            foundlanguages = staticData_store_1.default.languages.filter(function (e) { return JSON.parse(foundCountry_1.languageIds).includes(e.id); });
                            if (Array.isArray(foundlanguages) && foundlanguages.length > 0) {
                                return [2 /*return*/, foundlanguages.map(function (e) {
                                        return {
                                            id: e.id,
                                            name: e.name,
                                            updated: true,
                                            languageToUser: {
                                                languageId: e.id,
                                                languageProficiencyId: 3,
                                            },
                                            isoCode2: e.isoCode2,
                                        };
                                    })];
                            }
                        }
                    }
                    catch (err) {
                        console.log("Couldn't find language from country.");
                    }
                }
                foundLanguage = staticData_store_1.default.languages.find(function (e) { return e.isoCode2 === 'en'; });
                if (foundLanguage) {
                    return [2 /*return*/, [
                            {
                                id: foundLanguage.id,
                                name: foundLanguage.name,
                                updated: true,
                                languageToUser: {
                                    languageId: foundLanguage.id,
                                    languageProficiencyId: 3,
                                },
                                isoCode2: foundLanguage.isoCode2,
                            },
                        ]];
                }
                return [2 /*return*/];
        }
    });
}); };
exports.composeLanguage = composeLanguage;
/**
 *
 * @param {{ location?: string, city?: string, state?: string, countryId?: number, timezoneId?: number }} input
 * @returns {{ location?: string, city?: string, state?: string, countryId?: number, timezoneId?: number, country: object }}
 */
var composeLocation = function (input) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var splitLocation, _loop_1, splitLocation_1, splitLocation_1_1, potentialCountry, state_1, _loop_2, splitLocation_2, splitLocation_2_1, potentialCity, state_2, e_1_1, searchTerm, foundCountry, cityResponse, err_2, placeInfoResponse, err_3, extractedPlaceInfoResponse_1, timezone, foundCountry_2, timezoneResult_1, err_4, foundCountry, foundCountry, cityResponse, err_5, placeInfoResponse, err_6, extractedPlaceInfoResponse_2, timezone, foundCountry_3, timezoneResult_2, err_7, foundCountry;
    var e_2, _a, e_1, _b;
    return tslib_1.__generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!input) {
                    return [2 /*return*/];
                }
                if (!(input.location && (!input.city || !input.countryId))) return [3 /*break*/, 8];
                splitLocation = input.location.split(', ');
                if (!input.countryId) {
                    _loop_1 = function (potentialCountry) {
                        var foundCountry = staticData_store_1.default.countries.find(function (e) { return e.name == potentialCountry; });
                        if (foundCountry) {
                            input.countryId = foundCountry.id;
                            input.country = foundCountry;
                            return "break";
                        }
                    };
                    try {
                        for (splitLocation_1 = tslib_1.__values(splitLocation), splitLocation_1_1 = splitLocation_1.next(); !splitLocation_1_1.done; splitLocation_1_1 = splitLocation_1.next()) {
                            potentialCountry = splitLocation_1_1.value;
                            state_1 = _loop_1(potentialCountry);
                            if (state_1 === "break")
                                break;
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (splitLocation_1_1 && !splitLocation_1_1.done && (_a = splitLocation_1.return)) _a.call(splitLocation_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
                if (!(!input.countryId || (input.countryId && splitLocation.length != 1))) return [3 /*break*/, 8];
                _loop_2 = function (potentialCity) {
                    var potentialCityName, searchTerm, foundCountry, cityResponse, err_8, placeInfoResponse, err_9, extractedPlaceInfoResponse_3, timezone, foundCountry_4, timezoneResult_3, err_10;
                    return tslib_1.__generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                potentialCityName = potentialCity
                                    .replace(/(Government|of |the |The |Greater|Metropolitan|Bay |Area|Region|Rhine-Main)/g, '')
                                    .trim();
                                searchTerm = potentialCityName;
                                if (input.countryId) {
                                    foundCountry = staticData_store_1.default.countries.find(function (e) { return e.id == input.countryId; });
                                    if (foundCountry) {
                                        searchTerm = searchTerm + ' ' + foundCountry.name;
                                    }
                                }
                                cityResponse = null;
                                _d.label = 1;
                            case 1:
                                _d.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, (0, expertAutocomplete_1.getCitySuggestions)(searchTerm)];
                            case 2:
                                cityResponse = _d.sent();
                                return [3 /*break*/, 4];
                            case 3:
                                err_8 = _d.sent();
                                // Log error
                                console.log('Failed to fetch city suggestions.');
                                return [3 /*break*/, 4];
                            case 4:
                                if (!(cityResponse && cityResponse.length > 0)) return [3 /*break*/, 15];
                                if (!cityResponse[0].description.includes(potentialCityName)) {
                                    return [2 /*return*/, "continue"];
                                }
                                placeInfoResponse = null;
                                _d.label = 5;
                            case 5:
                                _d.trys.push([5, 7, , 8]);
                                return [4 /*yield*/, (0, expertAutocomplete_1.getPlaceInfoById)(cityResponse[0].place_id)];
                            case 6:
                                placeInfoResponse = _d.sent();
                                return [3 /*break*/, 8];
                            case 7:
                                err_9 = _d.sent();
                                // Log error
                                console.log('Failed to fetch place info by id');
                                return [3 /*break*/, 8];
                            case 8:
                                extractedPlaceInfoResponse_3 = null;
                                timezone = null;
                                if (!placeInfoResponse) return [3 /*break*/, 14];
                                _d.label = 9;
                            case 9:
                                _d.trys.push([9, 13, , 14]);
                                extractedPlaceInfoResponse_3 = (0, expertAutocomplete_1.extractPlaceInfo)(placeInfoResponse);
                                foundCountry_4 = staticData_store_1.default.countries.find(function (e) { return e.id === extractedPlaceInfoResponse_3.countryId; });
                                if (!foundCountry_4) return [3 /*break*/, 12];
                                if (!foundCountry_4.hasSingleTimezone) return [3 /*break*/, 10];
                                timezone = staticData_store_1.default.timezones.find(function (e) { return e.name === foundCountry_4.timezoneId; });
                                return [3 /*break*/, 12];
                            case 10: return [4 /*yield*/, (0, expertAutocomplete_1.getTimezone)(placeInfoResponse.geometry.location.lat, placeInfoResponse.geometry.location.lng)];
                            case 11:
                                timezoneResult_3 = _d.sent();
                                if (timezoneResult_3 === null || timezoneResult_3 === void 0 ? void 0 : timezoneResult_3.timeZoneId) {
                                    timezone = staticData_store_1.default.timezones.find(function (e) { return e.name === timezoneResult_3.timeZoneId; });
                                }
                                _d.label = 12;
                            case 12: return [3 /*break*/, 14];
                            case 13:
                                err_10 = _d.sent();
                                // Log error
                                console.log('Failed to extract place info or get timezone. 1');
                                console.log(JSON.parse(JSON.stringify(err_10)));
                                return [3 /*break*/, 14];
                            case 14:
                                if (extractedPlaceInfoResponse_3) {
                                    input.city = extractedPlaceInfoResponse_3.city;
                                    input.state = extractedPlaceInfoResponse_3.state ? extractedPlaceInfoResponse_3.state : '';
                                    input.countryId = extractedPlaceInfoResponse_3.countryId ? extractedPlaceInfoResponse_3.countryId : '';
                                }
                                input.timezoneId = timezone
                                    ? timezone.id
                                    : (extractedPlaceInfoResponse_3 === null || extractedPlaceInfoResponse_3 === void 0 ? void 0 : extractedPlaceInfoResponse_3.countryDefaultTimezoneId)
                                        ? extractedPlaceInfoResponse_3.countryDefaultTimezoneId
                                        : '';
                                return [2 /*return*/, "break"];
                            case 15: return [2 /*return*/];
                        }
                    });
                };
                _c.label = 1;
            case 1:
                _c.trys.push([1, 6, 7, 8]);
                splitLocation_2 = tslib_1.__values(splitLocation), splitLocation_2_1 = splitLocation_2.next();
                _c.label = 2;
            case 2:
                if (!!splitLocation_2_1.done) return [3 /*break*/, 5];
                potentialCity = splitLocation_2_1.value;
                return [5 /*yield**/, _loop_2(potentialCity)];
            case 3:
                state_2 = _c.sent();
                if (state_2 === "break")
                    return [3 /*break*/, 5];
                _c.label = 4;
            case 4:
                splitLocation_2_1 = splitLocation_2.next();
                return [3 /*break*/, 2];
            case 5: return [3 /*break*/, 8];
            case 6:
                e_1_1 = _c.sent();
                e_1 = { error: e_1_1 };
                return [3 /*break*/, 8];
            case 7:
                try {
                    if (splitLocation_2_1 && !splitLocation_2_1.done && (_b = splitLocation_2.return)) _b.call(splitLocation_2);
                }
                finally { if (e_1) throw e_1.error; }
                return [7 /*endfinally*/];
            case 8:
                if (!(input.city && (!input.countryId || !input.state || !input.timezoneId))) return [3 /*break*/, 23];
                input.city = input.city
                    .replace(/(Government|of |the |The |Greater|Metropolitan|Bay |Area|Region|Rhine-Main)/g, '')
                    .trim();
                searchTerm = input.city;
                if (input.countryId) {
                    foundCountry = staticData_store_1.default.countries.find(function (e) { return e.id == input.countryId; });
                    if (foundCountry) {
                        searchTerm = searchTerm + ' ' + foundCountry.name;
                    }
                }
                cityResponse = null;
                _c.label = 9;
            case 9:
                _c.trys.push([9, 11, , 12]);
                return [4 /*yield*/, (0, expertAutocomplete_1.getCitySuggestions)(searchTerm)];
            case 10:
                cityResponse = _c.sent();
                return [3 /*break*/, 12];
            case 11:
                err_2 = _c.sent();
                // Log error
                console.log('Failed to fetch city suggestions.');
                return [3 /*break*/, 12];
            case 12:
                if (!(cityResponse && cityResponse.length > 0 && cityResponse[0].description.includes(input.city))) return [3 /*break*/, 23];
                placeInfoResponse = null;
                _c.label = 13;
            case 13:
                _c.trys.push([13, 15, , 16]);
                return [4 /*yield*/, (0, expertAutocomplete_1.getPlaceInfoById)(cityResponse[0].place_id)];
            case 14:
                placeInfoResponse = _c.sent();
                return [3 /*break*/, 16];
            case 15:
                err_3 = _c.sent();
                // Log error
                console.log('Failed to fetch place info by id');
                return [3 /*break*/, 16];
            case 16:
                extractedPlaceInfoResponse_1 = null;
                timezone = null;
                if (!placeInfoResponse) return [3 /*break*/, 22];
                _c.label = 17;
            case 17:
                _c.trys.push([17, 21, , 22]);
                extractedPlaceInfoResponse_1 = (0, expertAutocomplete_1.extractPlaceInfo)(placeInfoResponse);
                foundCountry_2 = staticData_store_1.default.countries.find(function (e) { return e.id === extractedPlaceInfoResponse_1.countryId; });
                if (!foundCountry_2) return [3 /*break*/, 20];
                if (!foundCountry_2.hasSingleTimezone) return [3 /*break*/, 18];
                timezone = staticData_store_1.default.timezones.find(function (e) { return e.name === foundCountry_2.timezoneId; });
                return [3 /*break*/, 20];
            case 18: return [4 /*yield*/, (0, expertAutocomplete_1.getTimezone)(placeInfoResponse.geometry.location.lat, placeInfoResponse.geometry.location.lng)];
            case 19:
                timezoneResult_1 = _c.sent();
                if (timezoneResult_1 === null || timezoneResult_1 === void 0 ? void 0 : timezoneResult_1.timeZoneId) {
                    timezone = staticData_store_1.default.timezones.find(function (e) { return e.name === timezoneResult_1.timeZoneId; });
                }
                _c.label = 20;
            case 20: return [3 /*break*/, 22];
            case 21:
                err_4 = _c.sent();
                // Log error
                console.log('Failed to extract place info or get timezone. 2');
                console.log(JSON.parse(JSON.stringify(err_4)));
                return [3 /*break*/, 22];
            case 22:
                if (extractedPlaceInfoResponse_1) {
                    if (!input.countryId) {
                        foundCountry = staticData_store_1.default.countries.find(function (e) { return e.id == extractedPlaceInfoResponse_1.countryId; });
                        input.countryId = extractedPlaceInfoResponse_1.countryId;
                        input.country = foundCountry;
                    }
                    if (!input.state) {
                        input.state = extractedPlaceInfoResponse_1.state;
                    }
                }
                if (!input.timezoneId) {
                    input.timezoneId = timezone
                        ? timezone.id
                        : (extractedPlaceInfoResponse_1 === null || extractedPlaceInfoResponse_1 === void 0 ? void 0 : extractedPlaceInfoResponse_1.countryDefaultTimezoneId)
                            ? extractedPlaceInfoResponse_1.countryDefaultTimezoneId
                            : '';
                }
                _c.label = 23;
            case 23:
                if (!(input.countryId && (!input.city || !input.state || !input.timezoneId))) return [3 /*break*/, 38];
                foundCountry = staticData_store_1.default.countries.find(function (e) { return e.id == input.countryId; });
                if ((foundCountry === null || foundCountry === void 0 ? void 0 : foundCountry.capital) && !input.city) {
                    input.city = foundCountry.capital;
                }
                if (!(!input.state || !input.timezoneId)) return [3 /*break*/, 38];
                cityResponse = null;
                _c.label = 24;
            case 24:
                _c.trys.push([24, 26, , 27]);
                return [4 /*yield*/, (0, expertAutocomplete_1.getCitySuggestions)(input.city + ' ' + foundCountry.name)];
            case 25:
                cityResponse = _c.sent();
                return [3 /*break*/, 27];
            case 26:
                err_5 = _c.sent();
                // Log error
                console.log('Failed to fetch city suggestions.');
                return [3 /*break*/, 27];
            case 27:
                if (!(cityResponse && cityResponse.length > 0 && cityResponse[0].description.includes(input.city))) return [3 /*break*/, 38];
                placeInfoResponse = null;
                _c.label = 28;
            case 28:
                _c.trys.push([28, 30, , 31]);
                return [4 /*yield*/, (0, expertAutocomplete_1.getPlaceInfoById)(cityResponse[0].place_id)];
            case 29:
                placeInfoResponse = _c.sent();
                return [3 /*break*/, 31];
            case 30:
                err_6 = _c.sent();
                // Log error
                console.log('Failed to fetch place info by id');
                return [3 /*break*/, 31];
            case 31:
                extractedPlaceInfoResponse_2 = null;
                timezone = null;
                if (!placeInfoResponse) return [3 /*break*/, 37];
                _c.label = 32;
            case 32:
                _c.trys.push([32, 36, , 37]);
                extractedPlaceInfoResponse_2 = (0, expertAutocomplete_1.extractPlaceInfo)(placeInfoResponse);
                foundCountry_3 = staticData_store_1.default.countries.find(function (e) { return e.id === extractedPlaceInfoResponse_2.countryId; });
                if (!foundCountry_3) return [3 /*break*/, 35];
                if (!foundCountry_3.hasSingleTimezone) return [3 /*break*/, 33];
                timezone = staticData_store_1.default.timezones.find(function (e) { return e.name === foundCountry_3.timezoneId; });
                return [3 /*break*/, 35];
            case 33: return [4 /*yield*/, (0, expertAutocomplete_1.getTimezone)(placeInfoResponse.geometry.location.lat, placeInfoResponse.geometry.location.lng)];
            case 34:
                timezoneResult_2 = _c.sent();
                if (timezoneResult_2 === null || timezoneResult_2 === void 0 ? void 0 : timezoneResult_2.timeZoneId) {
                    timezone = staticData_store_1.default.timezones.find(function (e) { return e.name === timezoneResult_2.timeZoneId; });
                }
                _c.label = 35;
            case 35: return [3 /*break*/, 37];
            case 36:
                err_7 = _c.sent();
                // Log error
                console.log('Failed to extract place info or get timezone. 3');
                console.log(JSON.parse(JSON.stringify(err_7)));
                return [3 /*break*/, 37];
            case 37:
                if (extractedPlaceInfoResponse_2) {
                    input.state = extractedPlaceInfoResponse_2.state;
                }
                input.timezoneId = timezone
                    ? timezone.id
                    : (extractedPlaceInfoResponse_2 === null || extractedPlaceInfoResponse_2 === void 0 ? void 0 : extractedPlaceInfoResponse_2.countryDefaultTimezoneId)
                        ? extractedPlaceInfoResponse_2 === null || extractedPlaceInfoResponse_2 === void 0 ? void 0 : extractedPlaceInfoResponse_2.countryDefaultTimezoneId
                        : '';
                _c.label = 38;
            case 38:
                if (input.countryId && !input.country) {
                    foundCountry = staticData_store_1.default.countries.find(function (e) { return e.id == input.countryId; });
                    input.country = foundCountry;
                }
                return [2 /*return*/, input];
        }
    });
}); };
exports.composeLocation = composeLocation;
